import React, { useRef } from "react";
import Loading from "../components/Loading";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Button from "../components/Button";

const RandomPage = () => {
  const animation = useRef();

  const { id } = useParams();
  const [loading, setLoading] = React.useState(false);
  const [cocktail, setCocktail] = React.useState(null);

  React.useEffect(() => {
    setLoading(true);
    async function getCocktail() {
      try {
        const response = await fetch(
          `https://www.thecocktaildb.com/api/json/v1/1/random.php`
        );
        const data = await response.json();
        if (data.drinks) {
          const {
            strMeasure1,
            strMeasure2,
            strMeasure3,
            strMeasure4,
            strMeasure5,
            strMeasure6,
            strMeasure7,
            strMeasure8,
            strMeasure9,
            strMeasure10,
            strMeasure11,
            strMeasure12,
            strMeasure13,
            strMeasure14,
            strMeasure15,
            strDrink: name,
            strDrinkThumb: image,
            strAlcoholic: info,
            strGlass: glass,
            strInstructions: instructions,
            strIngredient1,
            strIngredient2,
            strIngredient3,
            strIngredient4,
            strIngredient5,
            strIngredient6,
            strIngredient7,
            strIngredient8,
            strIngredient9,
            strIngredient10,
            strIngredient11,
            strIngredient12,
            strIngredient13,
            strIngredient14,
            strIngredient15,
          } = data.drinks[0];

          const ingredients = [
            strIngredient1,
            strIngredient2,
            strIngredient3,
            strIngredient4,
            strIngredient5,
            strIngredient6,
            strIngredient7,
            strIngredient8,
            strIngredient9,
            strIngredient10,
            strIngredient11,
            strIngredient12,
            strIngredient13,
            strIngredient14,
            strIngredient15,
          ];

          const measures = [
            strMeasure1,
            strMeasure2,
            strMeasure3,
            strMeasure4,
            strMeasure5,
            strMeasure6,
            strMeasure7,
            strMeasure8,
            strMeasure9,
            strMeasure10,
            strMeasure11,
            strMeasure12,
            strMeasure13,
            strMeasure14,
            strMeasure15,
          ];

          const newCocktail = {
            name,
            image,
            info,
            glass,
            instructions,
            ingredients,
            measures,
          };
          setCocktail(newCocktail);
        } else {
          setCocktail(null);
        }
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    }
    getCocktail();
  }, [id]);
  if (loading) {
    return <Loading />;
  }
  if (!cocktail) {
    return <h2 className="error-message">No cocktail to display :&#40;</h2>;
  }

  const { name, image, info, glass, instructions, ingredients, measures } =
    cocktail;

  return (
    <div className="details-landing-page">
      <Header text="MIXOLOGY" />
      <div className="cocktail-detail-container">
        <div className="cover-ribbon">
          <div className="cover-ribbon-inside"> {info}</div>
        </div>
        <div className="left-side-details">
          <img className="detail-img" src={image} alt={name} />
        </div>
        <div className="right-side-details">
          <div className="detail-name">{name}</div>
          <div className="detail-text">
            <div className="detail-ingredients">
              <div className="detail-instructions-title">Ingredients :</div>
              <ul className="ingredients-list diamond">
                {ingredients.map((item, index) => {
                  console.log(ingredients);
                  return item ? (
                    <li key={index}>
                      {" "}
                      {measures[index]} &nbsp; {item}
                    </li>
                  ) : null;
                })}
              </ul>
            </div>
            <div className="text-spacer"></div>
            <div className="detail-glass">
              <span className="detail-instructions-title">Glass : &nbsp;</span>
              {glass}
            </div>
            <div className="text-spacer"></div>

            <div className="detail-instructions">
              <span className="detail-instructions-title">
                Instructions : &nbsp;
              </span>
              {instructions}
            </div>
          </div>
          <div className="button-container flex-end">
            <Button text="Back" link="/" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RandomPage;
